import { InternalAxiosRequestConfig } from 'axios';

import { getActiveAppLanguage } from '@shared/utils/userLanguage';

export const USER_LANG_HEADER = 'x-user-lang';

export const userLangHeaderInterceptor = (config: InternalAxiosRequestConfig) => {
  const activeAppLanguage = getActiveAppLanguage();

  if (config.headers && activeAppLanguage) {
    config.headers[USER_LANG_HEADER] = activeAppLanguage;
  }

  return config;
};
